module.exports = __webpack_public_path__ + "img/left_right_layout_4.2e89de7f.svg";